import React from 'react';
import { ResponsiveBar } from '@nivo/bar';

const MyResponsiveBar = ({ data, onClick, selectedSlice }) => (
    <ResponsiveBar
        theme={{
            labels: {
                text: {
                    fontSize: 10
                }
            }
        }}
        onClick={onClick}
        data={data}
        keys={['Funcionario']}
        // indexBy="id"
        margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
        cornerRadius={7}
        activeInnerRadiusOffset={9}
        activeOuterRadiusOffset={9}
        // colors={{ datum: 'data.color' }}
        colors={{ scheme: 'pastel2' }}
        borderColor={{
            from: 'color',
            modifiers: [
                [
                    'darker',
                    '0.2'
                ]
            ]
        }}
        enableArcLinkLabels={false}
        arcLabelsRadiusOffset={0.7}
        arcLabelsTextColor={{
            from: 'color',
            modifiers: [
                [
                    'darker',
                    '1.6'
                ]
            ]
        }}
        defs={[
            {
                id: 'dots',
                type: 'patternDots',
                background: 'inherit',
                color: 'rgba(255, 255, 255, 0.3)',
                size: 4,
                padding: 1,
                stagger: true
            },
            {
                id: 'lines',
                type: 'patternLines',
                background: 'inherit',
                color: 'rgba(255, 255, 255, 0.3)',
                rotation: -45,
                lineWidth: 6,
                spacing: 10
            }
        ]}
        fill={[
            {
                match: {
                    id: selectedSlice,
                },
                id: 'lines',
            },
        ]}
        // legends={[
        //     {
        //         dataFrom: 'keys',
        //         anchor: 'bottom-right',
        //         direction: 'column',
        //         justify: false,
        //         translateX: 120,
        //         translateY: 0,
        //         itemsSpacing: 2,
        //         itemWidth: 100,
        //         itemHeight: 20,
        //         itemDirection: 'left-to-right',
        //         itemOpacity: 0.85,
        //         symbolSize: 20,
        //         effects: [
        //             {
        //                 on: 'hover',
        //                 style: {
        //                     itemOpacity: 1
        //                 }
        //             }
        //         ]
        //     }
        // ]}
    // animate={true}
    // motionStiffness={90}
    // motionDamping={15}
    />
)

export default MyResponsiveBar;
